import { useEffect, useRef } from 'react';

import styles from './Message.module.css';

import hum from '../../assets/images/hum.webp';

export const Message = ({ message, rotateSign, speed }) => {
  const videoRef = useRef(null);
  const initDelay = speed / 1000 || 7;

  const videoUrl = message.attachments?.[0]?.url;
  const videoPoster = message.attachments?.[0]?.poster;

  useEffect(() => {
    if (!videoRef.current) return;

    const video = videoRef.current;

    const idTimeout = setTimeout(() => {
      if (!video.isConnected) return;

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((err) => {
          if (err.name !== 'AbortError') {
            console.error('play() error:', err);
          }
        });
      }
    }, speed + 600);

    return () => {
      clearTimeout(idTimeout);

      if (!video.paused) {
        video.pause();
      }
    };
  }, [initDelay, speed]);

  const videoErrHandler = (event) => {
    const video = event.currentTarget;

    if (video.poster !== hum) {
      video.poster = hum;
    }
  };

  return (
    <div
      className={styles.wrapper}
      style={{
        transform:
          rotateSign === '+' ? 'translateY(-4rem)' : 'translateY(7rem)',
      }}
    >
      <div className={styles.msg}>
        <div
          className={styles.msgVideo}
          style={{
            width: rotateSign === '+' ? '34rem' : '48rem',
            height: rotateSign === '+' ? '34rem' : '48rem',
            padding: rotateSign === '+' ? '3%' : '4%',
            '--delayMsg': `${initDelay + 0.6}s`,
          }}
        >
          <svg
            width="400"
            height="400"
            viewBox="0 0 400 400"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.borderVideo}
          >
            <defs>
              <linearGradient id="ringGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop
                  offset="0%"
                  stopColor="rgb(215, 205, 129)"
                  stopOpacity="0.1"
                />
                <stop
                  offset="42%"
                  stopColor="rgb(0, 162, 255)"
                  stopOpacity="0.78"
                />
              </linearGradient>
            </defs>

            <circle
              cx="200"
              cy="200"
              r="196"
              fill="none"
              stroke="url(#ringGrad)"
              strokeWidth="8"
            />
          </svg>

          <video
            playsInline
            ref={videoRef}
            muted="muted"
            loop
            onError={videoErrHandler}
            style={{ '--delayVideoMask': `${initDelay + 1.5}s` }}
          >
            <source src={videoUrl} poster={videoPoster || ''} />
          </video>
        </div>
      </div>
    </div>
  );
};
